export const reservationConversations = {
  tabs: {
    calls: "Llamadas",
    web: "Web",
    checkins: "Check-ins",
    charges: "Cargos",
    notes: "Notas",
  },
  checkinBadge: {
    allCompleted: "Todos los check-ins completados",
    manuallyResolved: "Envío final completado manualmente por un operador",
    progress: "{done}/{total} check-ins completados",
  },
  banners: {
    limitedMode:
      "Esta reserva no está operativa para flujo completo. Solo puedes usar WhatsApp y notas internas.",
    rejectedMode:
      "La solicitud fue rechazada. Solo quedan disponibles WhatsApp y notas internas.",
    autoReplying: "Agente está respondiendo automáticamente.",
  },
  search: {
    placeholder: "Buscar por nombre, teléfono o código de reserva...",
  },
  list: {
    emptyTitle: "Sin conversaciones todavía",
    emptyText:
      "Cuando el huésped escriba o le envíes un mensaje, la conversación aparecerá aquí.",
    noResultsTitle: "No se encontraron conversaciones",
    noResultsText: "Prueba con otro nombre, teléfono o código de reserva.",
    aiActiveTitle: "Agente IA activo",
    markAllRead: "Marcar todo como leído",
  },
  conversation: {
    windowTimer: "Ventana de mensajes: {hours}h restantes",
    copyPortalCopied: "Enlace copiado",
    copyPortalTooltip: "Copiar enlace de gestión",
    copiedShort: "Copiado",
    copyLinkShort: "Copiar enlace",
    dropToAttach: "Suelta para adjuntar los archivos",
    senderBot: "BOT / STAFF",
    senderGuest: "HUÉSPED",
    imageAlt: "Imagen enviada",
    locationReceived: "Ubicación recibida",
    viewFile: "Ver archivo",
    notSent: "No se envió",
    sending: "Enviando...",
    emptyTitle: "Sin mensajes aún",
    emptyText:
      "Inicia la conversación con una plantilla o espera a que el huésped escriba.",
  },
  mode: {
    ai: "IA",
    manual: "Manual",
    agentInactiveTooltip:
      "El Agente IA no está activo para esta propiedad. Actívalo desde la configuración del anuncio para que responda automáticamente.",
    agentInactiveChip: "Agente IA no activo",
  },
  composer: {
    predefinedTitle: "Respuestas predefinidas",
    predefinedEmpty: "No se encontraron respuestas predefinidas",
    attachFile: "Adjuntar archivo",
    inputPlaceholder: "Comience con / para seleccionar una respuesta predefinida.",
    removeFile: "Remover archivo",
    fileFallback: "archivo",
  },
  calls: {
    title: "Llamadas de esta reserva",
    none: "No hay llamadas asociadas a esta reserva.",
    caller: "Llamante",
    bookedFromCall: "Reservó desde esta llamada",
    pause: "Pausar",
    play: "Reproducir",
    downloadMp3: "Descargar MP3",
    noRecording: "Sin grabación",
  },
  ota: {
    noData: "No hay datos de reserva para cargar mensajes OTA.",
  },
  checkins: {
    title: "Check-ins de la reserva",
  },
  charges: {
    title: "Cargos de la reserva",
    noData: "No hay datos de reserva para cargar cargos.",
  },
  notes: {
    title: "Notas internas",
    noData: "No hay datos de reserva para cargar notas.",
  },
  time: {
    today: "Hoy {time}",
    yesterday: "Ayer {time}",
  },
  guestFallback: "Invitado",
  webGuestFallback: "Huésped",
  documentFallback: "Documento",
  location: {
    openInMaps: "Abrir en Google Maps",
    viewCoords: "Ver coordenadas ({lat}, {lng})",
  },
  delivery: {
    read: "Leído",
    delivered: "Entregado",
    queued: "En cola",
    failed: "Falló",
    sent: "Enviado",
  },
  errors: {
    genericSendFail: "No se pudo enviar este mensaje por WhatsApp.",
  },
  failureShort: {
    paymentIssue: "problema de pago en la cuenta de WhatsApp",
    cannotReceive: "el número no puede recibir WhatsApp",
    downloadFailed: "WhatsApp no pudo descargar el archivo",
    templateMissingData: "faltan datos en la plantilla",
    requirementsNotMet: "el mensaje no cumple los requisitos de WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "Sin WhatsApp",
    invalidNumber: "Número inválido",
    notSent: "No enviado",
  },
  alerts: {
    paymentIssue: "Problema de pago en WhatsApp",
    whatsappUnavailable: "WhatsApp no disponible",
    qualityReduced: "Calidad del número reducida",
  },
  toast: {
    reactivateNoConv: "No se pudo identificar la conversación para reactivarla.",
    templateSent: "Plantilla enviada correctamente.",
    reactivateFail: "No se pudo enviar la plantilla de reactivación.",
    cannotSendWhatsappTitle: "No se puede enviar por WhatsApp",
    invalidPhoneDetail:
      "El teléfono de esta reserva ({phone}) no es un número válido. Corrígelo en \"Editar reserva\" para poder escribirle.",
    noPhoneDetail:
      "Esta reserva no tiene teléfono. Añádelo en \"Editar reserva\" para poder escribirle.",
    sendErrorTitle: "Error al enviar",
    sendErrorDetail: "No se pudo enviar el mensaje",
    errorTitle: "Error",
    copyLinkFail: "No se pudo copiar el enlace",
    agentInactiveTitle: "Agente IA no activo",
    agentInactiveDetail:
      "Esta propiedad no tiene el Agente IA activo. Actívalo desde la configuración del anuncio.",
    noConvId: "No se pudo identificar la conversación",
    modeChangeFail: "No se pudo cambiar el modo del chat",
    agentUnavailableTitle: "Agente IA no disponible",
  },
};
